/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router';
import { object } from 'prop-types';
import Media from 'react-media';
import { compose } from 'recompose';
import ClubPage from './ClubPage';
import MobileClubPage from './MobileClubPage';

// strips "font-family:" and ";" from value
const parseFont = (font) => font?.match(/:\s(.*?);/, '')?.[1] || null;

const GraphqlClubPageBody = ({
    blocks,
}) => {
    const {
        seo, logo, heading, description, more_description, headerbackground, page_blocks, club_title_font,
    } = blocks;

    const clubTitleFontFamily = parseFont(club_title_font);
    const newSeo = { ...seo.location }; // cloned to handle immutability
    newSeo.location = { pathname: blocks.url };
    const clubTypeContent = [];
    const disclaimer = [];
    const subcollectionBlock = [];
    page_blocks.forEach((block) => {
        if (block.club_group?.reference?.length > 0) {
            clubTypeContent.push({ ...block?.club_group?.reference[0], gaConstants: block?.club_group.ga_constants });
        }
        if (block.disclaimer) {
            disclaimer.push(block.disclaimer);
        }
        if (block.subcollection) {
            subcollectionBlock.push(block.subcollection);
        }
    });

    return (
        <Media query="(max-width: 1024px)">
            {(matches) => (
                matches ? (
                    <MobileClubPage
                        heading={heading}
                        titleFontFamily={clubTitleFontFamily}
                        moreText={more_description}
                        headerbackground={headerbackground}
                        clubTypeContent={clubTypeContent}
                        Disclaimer={disclaimer}
                        subcollectionBlock={subcollectionBlock}
                    />
                ) : (
                    <ClubPage
                        logo={logo}
                        heading={heading}
                        titleFontFamily={clubTitleFontFamily}
                        text={description}
                        moreText={more_description}
                        headerbackground={headerbackground}
                        clubTypeContent={clubTypeContent}
                        Disclaimer={disclaimer}
                        seo={newSeo}
                        subcollectionBlock={subcollectionBlock}
                    />
                )
            )}
        </Media>
    );
};

GraphqlClubPageBody.propTypes = {
    blocks: object,
};

GraphqlClubPageBody.defaultProps = {
    blocks: {},
};

const enhance = compose(
    withRouter,
);

export default enhance(GraphqlClubPageBody);
